var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderAccessories = function SvgPlaceholderAccessories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.657 21h6.686a2 2 0 0 1 1.414.586L56.172 25H39.828l3.415-3.414A2 2 0 0 1 44.657 21ZM37 25l4.828-4.828A4 4 0 0 1 44.657 19h6.686a4 4 0 0 1 2.829 1.172L59 25h6a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4V29a4 4 0 0 1 4-4h6v-1a4 4 0 0 1 8 0v1h8Zm24 2H15a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h50a2 2 0 0 0 2-2V29a2 2 0 0 0-2-2h-4Zm-34-2v-1a2 2 0 1 0-4 0v1h4Zm21 24a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0 2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10-8c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm2 0c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12ZM21 33a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};
export default SvgPlaceholderAccessories;